import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, inject, type OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { Store } from '@ngxs/store';
import Parse from 'parse';
import { Observable } from 'rxjs';

import { LoggerService } from '@core/services/logger.service';
import { UserService } from '@core/services/user.service';

import { SiteState } from '@stores/site';
import { ToggleOffcanvasSite } from '@stores/site/site.actions';

import { ButtonModule } from 'primeng/button';
import { UserState } from '@stores/user';
import { Organization } from '@features/organizations/models/organization.model';
import { OrganizationsState } from '@stores/organizations';

@Component({
  selector: 'tr-main-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule],
  templateUrl: './main-menu.component.html',
  styleUrl: './main-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainMenuComponent implements OnInit {
  private logger: LoggerService = inject(LoggerService);
  private userService: UserService = inject(UserService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private router = inject(Router);
  private store: Store = inject(Store);

  isMenuShown$: Observable<boolean> = this.store.select(SiteState.isMenuShown());
  isOffcanvasShown$: Observable<boolean> = this.store.select(SiteState.isOffcanvasShown());

  showAccount: boolean = false;

  currentUser$: Observable<Parse.User | null | undefined> = this.store.select(UserState.getCurrentUser);
  currentOrg$: Observable<Organization | null | undefined> = this.store.select(OrganizationsState.getCurrentOrganization);

  constructor() {}

  ngOnInit(): void {}

  logout(event: Event) {
    this.userService.logout().subscribe({
      next: () => {
        this.router.navigate([`/login`]);
      },
    });
  }

  closeOffcanvas() {
    this.store.dispatch(new ToggleOffcanvasSite(true));
  }

  toggleAccount() {
    this.showAccount = !this.showAccount;
    this.cdr.detectChanges();
  }
}
